var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.3 0H0v40h53.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006400",
    d: "M-.2 0h82v40h-82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    d: "M-.2 5.7h82v28.6h-82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    d: "M-.2 11.4h82v17.2h-82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M-.2 17.1h82v5.7h-82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.9,
    d: "M-.2 0v40l27.4-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.2 0v40l27.4-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    d: "m10.2 10 5.4 16.2-14.2-10H19l-14.2 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m7.9 24.1 1-.1h2.4l1.4.2.1-.1v-1l.2-1 .3-.8.3-.8.4-.7.7.2h.2v-.2l-1.4-1.1-1.5-1.1-2-1.6h-.3l-.2-1.6-.2-.5-.2-.2-.4-.1H8l-.4.2h-.3l-.1.2v.2h.6l.2.1-.4.1h-.2l.2.2.2.1.3.1v3l-.1.7.2 1-.6.5-.3.6v.3l-.2.3v.5l.5 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.4 13.5-.4.1-.5.2q-.3 0-.4.3v.2h.3c1 0 .1.1 0 .1q-.2.1.4.4c.3 0 .3 0 .3 1.4v1.5q-.3.7 0 1.4v.3l-.3.4q-.6.6-.6 1v.3q-.3.3 0 .5l.6 2.5q-.2.2.8 0a13 13 0 0 1 3.8 0q.6.4.5-.4A7 7 0 0 1 14 20h.9l-2.5-2-2.7-2-.2-1-.2-1q-.2-.4-.8-.4zm0 .1h.2q.9-.2 1 1.3v1l-.3.2-1 1v.1-1.5q.1-1-.4-1t-.4-.2h.4l.1-.2-.5-.1-.3-.1q0-.3.4-.3l.4-.1zm1.5 2.5 4.9 3.8-2.7-.7c-2.3-.7-2.7-.8-2.8-1v-.5l.1-.2-.3.3q0 .4.2.7l1 .3 1 .4q0 .5-.8.8l-.5.2-1.7 1-.1.3q0 .4-.2.4v-.6l-.1.2v.2q-.1.1-.1-.2v-.3l-.2.5q0 .2 0 0v-.4l.1-.3.6-.7.8-.8.2-.6v-.3q-.2 0-.1.4l-.4.6-.7.7q-.6.5-.5.7l-.1.3v.3h-.1v-.5l-.1.2q0 .3-.1.2v-.4l.1-.3q.1-.6.6-1l.3-.4v-.3q-.3-.6 0-1.3 0-.5.7-1.1t1-.6m2.5 3.3.8.2.8.2-.2.3-.2.4q0 .3-.6.1l-2.1-.3H10l.3-.2.5-.2h.6q.6 0 .8-.3zM11 20v.1m.2 0v.1h-.1m.3 0v.1m.3 0v.1h-.1m-2 .8q1.7 0 3.4.4l-.2.5-.1.6h-.3a21 21 0 0 0-4.6 0l.1-.3v-.3L9 21q.5-.1 1-.6m-2.7 1.3.2.1.3.1q.3-.1.6 1.6v.4l-.2.1H8zm2.8.2h.3v.1q-.3.3-.4.1l-.1-.1zm.6 0h.6l-.2.2q0 .2-.2 0zm.8 0h.6l-.2.2-.1.1-.1-.1zm.9 0h.6l-.1.2h-.4zm-3 0v.2l-.2.2-.1-.1-.2-.2zm.2.1.2.1.2.2h-.6l.1-.1zm1.8 0 .2.2H11l.2-.1zm-.8 0 .1.1q.2.1-.1.1h-.3l.1-.1zm1.6 0 .2.1q.2.3 0 .2H12zm-3.4 0 .2.2v.1h-.2l-.3.1.1-.1zm-.4 0q.3 0 0 .3l-.1.1v-.3zm2.5.4 2 .2H8.3q.1-.2 2.6-.2m-1 .3h.5l-.1.1q-.2.3-.3 0zm.6 0 .2.1.1.2h-.6l.2-.2zm.2 0h.6l-.2.1q0 .3-.2 0zm-1.2 0-.2.2-.2-.1v-.2zm.2 0 .2.2h-.6l.2-.1zm1.7 0 .1.2q.3.2-.2 0h-.2.2zm.2 0h.2q.4 0 .1.2 0 .2-.2 0zm-3 0v.2q-.2.2-.2 0zm3.8.1h.4l-.1.2h-.3zm-3.5 0v.1q.3.1 0 .1h-.3.1zm3.3 0 .1.2h.1-.4l.1-.1m-1.9.3q1.4 0 2.3.2h.2v.8h-.6q-1.7-.4-3.4-.2h-.2v-.3l-.1-.3.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 20.7q-.5 0-.5.5.2.8.8.4c.4-.3.1-.9-.3-.9m0 .1.3.2v.2q0 .5-.5.4-.4-.4 0-.7zm-2-.1q-.5 0-.5.5c0 .4.6.7.9.3q.3-.6-.4-.8m0 0 .3.2.1.3q0 .4-.6.3-.3-.4 0-.7zm-1.6-6.9v.3h.2V14zm0 0v.2h-.2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.652f4fb303c0ee61c25d1f260f4d6dcd.svg";
export { ForwardRef as ReactComponent };